/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1TutoraiUsagePersonidLimitMutationRequest,
  PutApiV1TutoraiUsagePersonidLimitMutationResponse,
  PutApiV1TutoraiUsagePersonidLimitPathParams,
  PutApiV1TutoraiUsagePersonidLimit400,
  PutApiV1TutoraiUsagePersonidLimit401,
  PutApiV1TutoraiUsagePersonidLimit500,
} from "../../types/tutorAIUsageController/PutApiV1TutoraiUsagePersonidLimit.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1TutoraiUsagePersonidLimit } from "../../clients/tutorAIUsageController/putApiV1TutoraiUsagePersonidLimit.ts";

export const putApiV1TutoraiUsagePersonidLimitMutationKey = () =>
  [{ url: "/api/v1/tutorai/usage/:personId/limit" }] as const;

export type PutApiV1TutoraiUsagePersonidLimitMutationKey = ReturnType<
  typeof putApiV1TutoraiUsagePersonidLimitMutationKey
>;

export function putApiV1TutoraiUsagePersonidLimitMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1TutoraiUsagePersonidLimitMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1TutoraiUsagePersonidLimitMutationKey();
  return mutationOptions<
    PutApiV1TutoraiUsagePersonidLimitMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiUsagePersonidLimit400
      | PutApiV1TutoraiUsagePersonidLimit401
      | PutApiV1TutoraiUsagePersonidLimit500
    >,
    {
      personId: PutApiV1TutoraiUsagePersonidLimitPathParams["personId"];
      data?: PutApiV1TutoraiUsagePersonidLimitMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ personId, data }) => {
      return putApiV1TutoraiUsagePersonidLimit(personId, data, config);
    },
  });
}

/**
 * @description Sobrescreve os limites individuais de tokens diário, semanal e mensal do aluno. Use `0` em qualquer limite para remover o valor individual (aplica o padrão global). `enabled = false` desabilita o bloqueio independente dos valores configurados. **(Requer Authorization para autenticação)**
 * @summary Configurar limites de tokens do aluno (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/usage/:personId/limit}
 */
export function usePutApiV1TutoraiUsagePersonidLimit<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1TutoraiUsagePersonidLimitMutationResponse,
      ResponseErrorConfig<
        | PutApiV1TutoraiUsagePersonidLimit400
        | PutApiV1TutoraiUsagePersonidLimit401
        | PutApiV1TutoraiUsagePersonidLimit500
      >,
      {
        personId: PutApiV1TutoraiUsagePersonidLimitPathParams["personId"];
        data?: PutApiV1TutoraiUsagePersonidLimitMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1TutoraiUsagePersonidLimitMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1TutoraiUsagePersonidLimitMutationKey();

  const baseOptions = putApiV1TutoraiUsagePersonidLimitMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1TutoraiUsagePersonidLimitMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiUsagePersonidLimit400
      | PutApiV1TutoraiUsagePersonidLimit401
      | PutApiV1TutoraiUsagePersonidLimit500
    >,
    {
      personId: PutApiV1TutoraiUsagePersonidLimitPathParams["personId"];
      data?: PutApiV1TutoraiUsagePersonidLimitMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1TutoraiUsagePersonidLimitMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiUsagePersonidLimit400
      | PutApiV1TutoraiUsagePersonidLimit401
      | PutApiV1TutoraiUsagePersonidLimit500
    >,
    {
      personId: PutApiV1TutoraiUsagePersonidLimitPathParams["personId"];
      data?: PutApiV1TutoraiUsagePersonidLimitMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1TutoraiUsagePersonidLimitMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiUsagePersonidLimit400
      | PutApiV1TutoraiUsagePersonidLimit401
      | PutApiV1TutoraiUsagePersonidLimit500
    >,
    {
      personId: PutApiV1TutoraiUsagePersonidLimitPathParams["personId"];
      data?: PutApiV1TutoraiUsagePersonidLimitMutationRequest;
    },
    TContext
  >;
}
